module.exports = __webpack_public_path__ + "img/green-square-table-3.3147b588.png";